import React, { useCallback, useContext } from 'react';
import { RicosViewerContext } from 'ricos-context';
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from './viewer-loadable.js';
import { ButtonData_Type, Node_Type } from 'ricos-schema';
import { normalizeHref, getRelValue } from 'wix-rich-content-common';
import '@loadable/component';
import 'ricos-types';

var styles = {"button_container":"_2b9qo","button_text":"v1-qY","button_size_content":"p7-cw"};

var ROOT = "buttonViewer";

function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var ButtonViewer = function ButtonViewer(_ref) {
  var onClick = _ref.onClick,
    helpers = _ref.helpers,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings,
    buttonData = _ref.buttonData;
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  var isActionButton = buttonData.type === ButtonData_Type.ACTION;
  var onClickHandler = useCallback(function () {
    var _a2;
    (_a2 = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a2.call(helpers, isActionButton ? ACTION_BUTTON_TYPE : LINK_BUTTON_TYPE, "Click", "", void 0, {
      type: Node_Type.BUTTON,
      buttonData: buttonData
    });
    onClick == null ? void 0 : onClick();
  }, [helpers == null ? void 0 : helpers.onViewerAction]);
  var ButtonComponent = settings.customComponent ? settings.customComponent : isActionButton ? ActionButton : LinkButton;
  var style = {
    color: (_d = (_b = (_a = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _a.colors) == null ? void 0 : _b.text) != null ? _d : (_c = settings.colors) == null ? void 0 : _c.color1,
    background: (_h = (_f = (_e = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _e.colors) == null ? void 0 : _f.background) != null ? _h : (_g = settings.colors) == null ? void 0 : _g.color8,
    borderRadius: (_j = (_i = buttonData.styles) == null ? void 0 : _i.border) == null ? void 0 : _j.radius,
    width: "min(100%, " + ((_l = (_k = buttonData.containerData) == null ? void 0 : _k.width) == null ? void 0 : _l.custom) + "px)",
    border: (((_n = (_m = buttonData.styles) == null ? void 0 : _m.border) == null ? void 0 : _n.width) || 0) + "px solid " + ((_r = (_p = (_o = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _o.colors) == null ? void 0 : _p.border) != null ? _r : (_q = settings.colors) == null ? void 0 : _q.color8)
  };
  return /* @__PURE__ */React.createElement(ButtonComponent, __spreadValues({
    className: styles.button_container,
    style: style,
    "data-hook": ROOT,
    onClick: onClickHandler,
    tabIndex: 0,
    role: "button",
    buttonData: buttonData,
    onKeyDown: function onKeyDown(e) {
      if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        onClickHandler();
      }
    }
  }, !isActionButton && {
    href: ((_s = buttonData.link) == null ? void 0 : _s.url) && normalizeHref(buttonData.link.url),
    target: ((_t = buttonData.link) == null ? void 0 : _t.target) && "_" + buttonData.link.target.toLowerCase(),
    rel: ((_v = (_u = buttonData.link) == null ? void 0 : _u.rel) == null ? void 0 : _v.nofollow) ? getRelValue("nofollow") : void 0
  }));
};
var LinkButton = function LinkButton(props) {
  var _a = props,
    buttonData = _a.buttonData,
    rest = __objRest(_a, ["buttonData"]);
  return /* @__PURE__ */React.createElement("a", __spreadValues({}, rest), /* @__PURE__ */React.createElement("div", {
    className: styles.button_text
  }, buttonData.text));
};
var ActionButton = function ActionButton(props) {
  var _a = props,
    buttonData = _a.buttonData,
    rest = __objRest(_a, ["buttonData"]);
  return /* @__PURE__ */React.createElement("div", __spreadValues({}, rest), /* @__PURE__ */React.createElement("div", {
    className: styles.button_text
  }, buttonData.text));
};

var Button = function Button(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  var _a;
  var _useContext = useContext(RicosViewerContext),
    helpers = _useContext.helpers,
    config = _useContext.config,
    onNodeClick = _useContext.onNodeClick;
  var settings = ((_a = node.buttonData) == null ? void 0 : _a.type) === "ACTION" ? config[ACTION_BUTTON_TYPE] : config[LINK_BUTTON_TYPE];
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    key: node.id,
    node: node,
    nodeIndex: nodeIndex
  }, /* @__PURE__ */React.createElement(ButtonViewer, {
    helpers: helpers,
    settings: settings,
    buttonData: node.buttonData,
    onClick: function onClick() {
      return onNodeClick == null ? void 0 : onNodeClick({
        node: node
      });
    }
  }));
};

export { Button as default };

import 'wix-rich-content-plugin-button/dist/loadable/viewer/es/styles.viewer.min.global.css'